<template>
  <div class="teaching-arrange-schedule-add-main">
    <div class="body"
         v-loading="committing"
         element-loading-text="数据提交中，请稍等...">
      <el-form size="mini"
               label-width="72px">
        <el-form-item label="班级"
                      class="required">
          <el-select v-model="form.clazzId"
                     filterable
                     placeholder="请选择班级">
            <template v-if="detailInfo.classes">
              <el-option v-for="clazz in detailInfo.classes"
                         :key="clazz.id"
                         :label="clazz.name"
                         :value="clazz.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="课程"
                      class="required">
          <el-select v-model="form.planCourseId"
                     filterable
                     placeholder="请选择课程"
                     loading-text="数据加载中..."
                     :no-data-text="form.clazzId ? '没有可安排的课程' : '请先选择班级'"
                     :loading="planCourse.loading">
            <template v-if="planCourse.dataList">
              <el-option v-for="item in planCourse.dataList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="上课日期">
          <el-date-picker v-model="form.lessonDate"
                          type="date"
                          prefix-icon="el-icon-date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择上课日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="上课时段">
          <el-select v-model="form.lessonPeriod"
                     multiple
                     clearable
                     placeholder="请选择上课时段（多选将生成多条排课）">
            <template v-if="detailInfo.periods">
              <el-option v-for="period in detailInfo.periods"
                         :key="period.id"
                         :label="period.name"
                         :value="period.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="授课教师">
          <el-select v-model="form.lessonTeacherId"
                     filterable
                     clearable
                     placeholder="请选择授课教师">
            <template v-if="detailInfo.teachers">
              <el-option v-for="teacher in detailInfo.teachers"
                         :key="teacher.id"
                         :label="teacher.name"
                         :value="teacher.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="授课地点">
          <AddressSelector v-model="form.lessonPlace"
                          :coordinates="form.tencentMapLocation"
                          :site-id="extraParams && extraParams.site"
                          :map-key="mapKey"
                          :circle-radius="circleRadius"
                          @address-change="onAddressChange"></AddressSelector>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark"
                    type="textarea"
                    maxlength="500"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交保存</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint'
import AddressSelector from '../../../../../../../widgets/tencent/AddressSelector'
export default {
  name: 'TeachingArrangeScheduleAddMain',
  components: {
    Hint,
    AddressSelector
  },
  props: {
    detailInfo: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean,
    mapKey: {
      type: String,
      required: true
    },
    circleRadius: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      planCourse: {
        loading: false,
        dataList: []
      },
      form: {
        clazzId: '',
        planCourseId: '',
        lessonDate: '',
        lessonPeriod: [],
        lessonTeacherId: '',
        lessonPlace: '',
        tencentMapLocation: '',
        remark: ''
      },
      committing: false
    }
  },
  methods: {
    loadPlanCourses () {
      this.planCourse.dataList = null
      if (this.form.clazzId) {
        this.planCourse.loading = true
        this.$ajax({
          url: '/workspace/manager/teaching/schedule/arrange/planCourses',
          method: 'post',
          data: this.$qs.stringify(this.$extend(this.extraParams, {
            clazzId: this.form.clazzId
          }))
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.planCourse.dataList = response.data['planCourses'] || []
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.planCourse.loading = false
        })
      }
    },
    onAddressChange (address, coordinates) {
      this.form.lessonPlace = address
      this.form.tencentMapLocation = coordinates
    },
    handleApply () {
      if (!this.form.clazzId) {
        this.$message.warning('请选择班级')
        return
      }
      if (!this.form.planCourseId) {
        this.$message.warning('请选择课程')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/add/submit',
        method: 'post',
        data: this.$qs.stringify(this.$extend(this.extraParams, this.form), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$emit('addSuccess')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          let getVal = this.form[key]
          if (Array.isArray(getVal)) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        })
      }
    },
    'form.clazzId': {
      handler () {
        this.loadPlanCourses()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .teaching-arrange-schedule-add-main {
    height: 100%;
    display: flex;
    flex-direction: column;

    & > .body {
      flex: auto;
      min-height: 0;
      overflow-y: auto;
      padding: 20px 25px 20px 10px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          &.required {
            .el-form-item__label {
              position: relative;
              &:before {
                content: '*';
                color: #f56c6c;
                padding-right: 4px;
              }
            }
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .el-select,
            .el-date-editor,
            .el-textarea {
              width: 100%;
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
